import React, { useState, useEffect } from 'react';
import { getLocalStorageData, handleDataStructure } from './helpers.js';

const CountdownTimer = ({ stopTimer, timer }) => {

  const targetDate = new Date(timer.time);
  const [timeRemaining, setTimeRemaining] = useState("");
  const [help, setHelp] = useState(true)

  let storeData = getLocalStorageData()
  useEffect(() => {
    const timerInterval = setInterval(calculateTimeRemaining, 1000);
    setHelp(storeData.kaba_info.help)

    return () => {
      clearInterval(timerInterval);
    };
  }, [timer.time]);

  const calculateTimeRemaining = () => {
    const currentDate = new Date();

    const timeRemainingMillis = targetDate - currentDate;

    if (timeRemainingMillis <= 0) {
      stopTimer({ ...timer, 'is': false })
      { help && viderHelpInformation() }
      setTimeRemaining("Le délai est écoulé !");
    } else {
      const minutes = Math.floor((timeRemainingMillis / 1000 / 60) % 60);
      const seconds = Math.floor((timeRemainingMillis / 1000) % 60);
      setTimeRemaining(`${minutes}m ${seconds}s`);
    }
  };

  const viderHelpInformation = () => {
    handleDataStructure('help', false)
    handleDataStructure('ticket.data', '')
    handleDataStructure('signin', '')
    window.location.reload()
  }

  return (
    <div>
      {
        help ?
          <div>
            {
              timeRemaining <= 0 ? '' :
                <p style={{ fontSize: '18px', marginTop: "25px" }}>
                  Tu vas être automatiquement redirigé vers la page de connexion dans : <div>{' '}</div>
                  {timeRemaining}</p>
            }
          </div> :
          <div>
            {
              timeRemaining <= 0 ? '' :
                <p style={{ fontSize: '18px' }}>Tu n’as pas reçu le code ?  <br />
                  Réessaye dans : {timeRemaining}</p>
            }
          </div>
      }
    </div>
  );
};

export default CountdownTimer;
